import type { StatusDotTone } from "@/presentation/components/status/status-dot";
import type {
  B2cTaskKind,
  B2cTaskPriority,
  IterationStatus,
} from "@/infrastructure/supabase/b2c-board.types";

export const ITERATION_STATUS_LABEL: Record<IterationStatus, string> = {
  planned: "Planned",
  marathon: "Marathon running",
  feedback: "Awaiting feedback",
  merged: "Merged",
};

export const ITERATION_STATUS_TONE: Record<IterationStatus, StatusDotTone> = {
  planned: "open",
  marathon: "amber",
  feedback: "cyan",
  merged: "resolved",
};

/** The bar colour per iteration status — same hues as the status dots. */
export const ITERATION_BAR_CLASS: Record<IterationStatus, string> = {
  planned: "bg-[var(--muted-foreground)]",
  marathon: "bg-[var(--rag-amber)]",
  feedback: "bg-[var(--rag-cyan)]",
  merged: "bg-[var(--rag-green)]",
};

export const B2C_BOARD_SUMMARY =
  "The B2C MVP for 1 December, run in two stages: per system first, then per cross-system flow. Each workstream ships in iterations; an iteration runs as one marathon on its own integration branch, ends with an output document, gets feedback, and is merged. Work found during a marathon joins it; feedback after a marathon goes to the next iteration.";

export const PRIORITY_ORDER: B2cTaskPriority[] = ["must", "should", "after"];

export const PRIORITY_LABEL: Record<B2cTaskPriority, string> = {
  must: "Must · 1 Dec",
  should: "Should · 1 Dec",
  after: "After cutover",
};

/** Short badge text and tone class per priority. */
export const PRIORITY_BADGE: Record<B2cTaskPriority, { text: string; className: string }> = {
  must: { text: "MUST", className: "text-[oklch(0.5_0.19_25)] bg-[oklch(0.62_0.22_25_/_0.1)]" },
  should: {
    text: "SHOULD",
    className: "text-[oklch(0.5_0.13_70)] bg-[oklch(0.74_0.16_80_/_0.14)]",
  },
  after: { text: "AFTER", className: "text-muted-foreground bg-muted" },
};

export const KIND_ORDER: B2cTaskKind[] = [
  "decision",
  "add",
  "enhance",
  "reconfigure",
  "carry-over",
  "e2e",
];

export const KIND_LABEL: Record<B2cTaskKind, string> = {
  add: "New",
  enhance: "Enhance",
  reconfigure: "B2B → B2C",
  "carry-over": "Carry-over",
  decision: "Decision",
  e2e: "E2E proof",
};
